<template>
    
  <div class="cc-company-acd">
     
      <div class="panel cc-panel-default"  v-for="acdAgent in acdAgents">
        <div>
          <i class="fa fa-user fa-lg"
             :class="{ 'loading': loading }" 
             :style="{ color: getColor(acdAgent.status)}"
             aria-hidden="true">
             </i>
           <b>{{acdAgent.name}}</b>
           <small>({{acdAgent.id}})</small>
            <div class="pull-right">
              {{acdAgent.status}}
            </div>
        </div>
      </div>
      
      <div v-show="!acdAgents.length" class="alert alert-warning" role="alert">Keine ACD Agenten gefunden</div>

  </div>
                   
    
</template>



<script>

import bus from './common/bus'
import moment from 'moment'  

const INTERVAL = 10000 

export default {
    
  components: {
  },
  
  data () {
    return {
      acdAgents: [],
      interval: null,
      loading: false
    }
  },
  
  created: function () {
    
    bus.registerOnIdCompanyClient(this.onIdCompanyClient);
    
  },

  mounted: function () {
    // Nach F5 holen wir uns die History Daten
    if(bus.isLoggedIn()){
      this.startInterval()
    }
  },
 
  beforeDestroy: function () {
    this.stopInterval()
  },
  

  
  computed: {
    
    
  },
  
  methods: {
    
    isInterval: function () {
      return !!this.interval
    },

    startInterval: function () {
      // alwais clear interval...
      this.stopInterval()
      // ... and than start
      this.interval = setInterval(this.load, INTERVAL)
      this.$emit('status', true) // inform parent about status
      this.load() // 
    },

    stopInterval: function () {
      clearInterval(this.interval)
      this.interval = null
      this.$emit('status', false) // inform parent about status
    },

      
    getColor: function (status) {
      const default_color = "#337ab7"
      const statis = {
          'offline':   '#cccccc',
          'paused':    '#e0d050',
          'alerting':  '#ff0000',
          'timeouted': '#ed64ff',
          'connected': '#40bc45',
          'working': '#8b8b8b',
      }
      
      let color = statis[status] || default_color
      return color;
      
    },

    
    onIdCompanyClient: function (idCompanyClient, event, call) {
      //this.reset();
      
      // alwais clear interwall
      this.stopInterval()
      
      if(idCompanyClient == 0){
        this.startInterval()
        this.load();
      }
      
    },

    reset: function () {
      this.acdAgents = [];
    },
  
    refresh: function () {
      this.load();
    },
    
    load: function (query,options ) {
      this.loading = true;
      this.$http.get(bus.config.path + '/acd/agents').then((response) => {
        // nur wenn wir etwas bekommen
        //if(response.data.length){
          this.acdAgents = response.data
          this.loading = false;
        //}
        //console.log(response.data)

      }, (response) => {
          acdAgents: []
          this.loading = false;
      });
    },

    
  }
  
}
</script>



<style scoped>
  
  .cc-panel-default:hover{
     background-color: #fcf8e3;
  }
  
  .cc-msg{
    overflow: hidden;
    white-space: nowrap;
    margin-right: 10px;
  } 
  
  .fa-user{
    opacity: 1;
    transition:all 500ms ease-out;  
    transform: rotateY(0deg);
    transform-origin: 25% 25%; 
  }
  .loading{
    opacity: 0.9;
    transition: all 500ms ease-out;
    transform-origin: 25% 25%; 
    transform: rotateY(90deg);
  }  
  
h2 .fa, .panel .fa {
    padding-right: 12px;
    color: #337ab7;
}
  
  small{
    color: gray;
  }  
  
.panel {
    margin-bottom: 4px;
    border-bottom: 1px solid lightgrey;
    padding-bottom: 12px;  
    padding-top: 12px;  
}

.panel-title{
  font-size: 14px  ;
}

.cc-company-acd{
    height: 100%;
    overflow: auto;
  }

</style>



// WEBPACK FOOTER //
// CompanyAcd.vue?bd67af3a